import { Outlet } from "react-router-dom";
import { LanguageProvider } from "@/hooks/use-language";
import { SEO } from "@/components/SEO";

const LanguageLayout = () => {
  return (
    <LanguageProvider>
      <SEO />
      <Outlet />
    </LanguageProvider>
  );
};

export default LanguageLayout;
